import React from 'react';
import { classNames } from '..';
import './MaterialIcon.scss';
export const MaterialIcon = ({ name, extralarge, large, small, type, inline, className, style, onClick, id }) => React.createElement("span", { style: style, onClick: onClick, id: id, className: classNames({
        'extra-large': extralarge,
        large,
        'material-inline': inline,
        small,
        [`text-${type}`]: !!type,
    }, className || '', 'material-symbols-outlined') }, name);
export const MaterialIconText = ({ onClick, iconSide = 'left', ...props }) => React.createElement("div", { className: classNames({
        'material-symbols-outlined-text-clickable': !!onClick,
    }, 'material-symbols-outlined-text'), onClick: onClick },
    iconSide === 'left' && React.createElement(MaterialIcon, { ...props }),
    React.createElement("div", null, props.children),
    iconSide === 'right' && React.createElement(MaterialIcon, { ...props }));
//# sourceMappingURL=MaterialIcon.js.map